<template>
  <svg :height="height" viewBox="0 0 200 40" xmlns="http://www.w3.org/2000/svg">
    <text
      x="0"
      y="28"
      font-family="Segoe UI, Arial, sans-serif"
      font-size="36"
      font-weight="bold"
      :fill="colorsComputed.start"
      letter-spacing="2"
    >
      Kebun
    </text>
    <text
      x="130"
      y="12"
      font-family="Segoe UI, Arial, sans-serif"
      font-size="18"
      font-weight="bold"
      :fill="colorsComputed.start"
      letter-spacing="1"
    >
      ku
    </text>
  </svg>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
  }>(),
  {
    height: 40,
    start: 'primary',
    end: undefined,
  },
)

const colorsComputed = computed(() => {
  return {
    start: getColor(props.start),
    end: getColor(props.end || props.start),
  }
})
</script>
